module.exports = __webpack_public_path__ + "media/images/payments/webmoney-dark-bb68b84b67a3105d6f95bd037671a959.svg";